import React from 'react';
import AboutSection from './AboutSection';
import SubSection from './SubSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faLaptopCode,
  faCogs,
  faUsers,
  faProjectDiagram,
  faMobileAlt,
  faLightbulb,
} from '@fortawesome/free-solid-svg-icons';

const About: React.FC = () => {
  const professionalTitle = 'My Professional Journey';
  const professionalContent =
    "I'm Alam Khan, a tech enthusiast and product architect with 17+ years of experience in building scalable, intelligent, and user-focused solutions across industries. My expertise in Java, Golang, Node.js, Spring Boot, and cloud-native microservices has allowed me to architect digital products that are both innovative and dependable. I specialize in creating enterprise-grade systems, including blockchain apps, real-time analytics, and AI-driven platforms.";

  const tadwiroTitle = 'Tadwiro – Smart Construction Management Platform';
  const tadwiroContent =
    "Tadwiro is a flagship SaaS product developed at Ayser World to digitally transform the way construction and infrastructure projects are managed. It is designed for modern construction companies, real estate firms, and government contractors who need full visibility and control over their projects.";

  const tadwiroFeatures = [
    {
      title: '📝 Contracts Management',
      description: 'Manage tenders, bids, evaluations, and full contract lifecycle digitally.',
      icon: faProjectDiagram,
    },
    {
      title: '👷 Tenants & Users',
      description: 'Multi-tenant architecture with secure role-based access for users.',
      icon: faUsers,
    },
    {
      title: '📁 Projects & Tasks',
      description: 'Plan, assign, track, and complete construction tasks and milestones.',
      icon: faCogs,
    },
    {
      title: '🧾 Payroll & Attendance',
      description: 'Automated payroll, attendance, and workforce tracking.',
      icon: faLaptopCode,
    },
    {
      title: '🚛 Vehicles & Insurance',
      description: 'Track vehicle health, documents, and insurance renewals.',
      icon: faBuilding,
    },
    {
      title: '📊 Reports & Analytics',
      description: 'Real-time dashboards and status-based insights for decision making.',
      icon: faLightbulb,
    },
  ];

  const whatsDriveMeTitle = 'What Drives Me';
  const WhatsDriveMeContent =
    'Building impactful software is not just a profession — it’s my passion. I believe in leveraging technology to solve real-world challenges, improve processes, and empower users. Innovation, ownership, and curiosity fuel my work every day.';

  const personalTitle = 'Beyond the Code';
  const personalContent =
    'Outside of work, I’m a gamer, a movie buff, and a curious reader. My family keeps me grounded, and my hobbies keep me inspired. Whether it’s learning a new framework or strategizing in a game, I love to explore, adapt, and grow.';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center p-8 text-gray-800">
      {/* Main About Header */}
      <AboutSection title="About Ayser World" iconName="globe" />

      {/* Product Section */}
      <div className="max-w-5xl w-full bg-white p-6 rounded-lg shadow-md mt-6">
        <h2 className="text-2xl font-bold text-indigo-600 mb-4">{tadwiroTitle}</h2>
        <p className="mb-4 text-gray-700">{tadwiroContent}</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {tadwiroFeatures.map((feature, index) => (
            <div
              key={index}
              className="bg-indigo-100 p-4 rounded-lg shadow hover:shadow-lg transition transform hover:-translate-y-1"
            >
              <div className="flex items-center mb-2 text-indigo-700 text-xl font-semibold">
                <FontAwesomeIcon icon={feature.icon} className="mr-2" />
                {feature.title}
              </div>
              <p className="text-sm text-gray-700">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Professional Journey */}
      <SubSection title={professionalTitle} content={professionalContent} />

      {/* Personal Section */}
      <SubSection title={personalTitle} content={personalContent} />

      {/* Motivation Section */}
      <SubSection title={whatsDriveMeTitle} content={WhatsDriveMeContent} />
    </div>
  );
};

export default About;